import Richtext from './richtext';

export class LegalComponent {
  content: Richtext | null;

  constructor(props: any) {
    this.content = props.content ? new Richtext(props.content) : null;
  }
}

export default LegalComponent;
